import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right",
  "use": "icon-right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-right\"><path d=\"M299.52 992.768c-9.728 0-19.456-3.584-27.136-11.264-14.848-14.848-14.848-39.424 0-54.272L672.256 527.36 272.384 127.488c-14.848-14.848-14.848-39.424 0-54.272 14.848-14.848 39.424-14.848 54.272 0l427.008 427.008c14.848 14.848 14.848 39.424 0 54.272L326.656 981.504c-7.68 7.68-17.408 11.264-27.136 11.264z\" p-id=\"5896\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol